import type { DriveDealFacts, DriveFolderRecipe } from "@/lib/ops/driveFolderRecipe";
import { expandDriveFolderRecipe } from "@/lib/ops/driveFolderRecipe";
import { driveFolderTokensFromDeal } from "@/lib/ops/driveFolderTemplate";

export const DRIVE_RECIPE_PREVIEW_TOKENS = driveFolderTokensFromDeal({
  dealId: "8576900e-3a48-48d0-bfa0-9279cb8ff0e4",
  displayName: "Jane Doe · 12345",
  createdAt: "2026-09-15T12:00:00.000Z",
  customer: "Jane Doe",
  order: "12345",
});

export function previewDriveFolderRecipe(recipe: DriveFolderRecipe, facts: DriveDealFacts): string {
  const segs = expandDriveFolderRecipe(recipe, DRIVE_RECIPE_PREVIEW_TOKENS, facts);
  return segs.length ? `Root / ${segs.join(" / ")}` : "(no folders — check match rules)";
}
